import { WSElement, WSSectionToolbar } from "@wingspanhq/fe-component-library";
import {
  IPayerEngagementResponse,
  IPayerResponse,
  IWorkLog
} from "@wingspanhq/payments/dist/interfaces";
import { useInvoiceQuery } from "../../../query/payments/queries";
import { DataView } from "../../../shared/components/DataView";
import { getPayerName } from "../../Payers/utils/getPayerNames";
import { getWorkLogPayeeStatusCellProps } from "../utils/getWorkLogPayeeStatusCellProps";

type Props = {
  shimmer?: boolean;
  workLog?: IWorkLog;
  payer?: IPayerResponse;
  payerPayeeEngagement?: IPayerEngagementResponse;
};

export const WorkLogAssignmentInfoPayeeView: React.FC<Props> = props => {
  const queryInvoice = useInvoiceQuery(props.workLog?.invoiceId!, {
    enabled: !!props.workLog?.invoiceId
  });

  const statusCellProps = props.workLog
    ? getWorkLogPayeeStatusCellProps({
        workLog: props.workLog,
        invoice: queryInvoice.data
      })
    : undefined;

  const name = props.payer ? getPayerName(props.payer) : undefined;

  return (
    <WSElement>
      <WSSectionToolbar title="Assignment information" />
      <DataView
        shimmer={props.shimmer}
        data={[
          {
            label: "Assignment name",
            value: props.payerPayeeEngagement?.engagementName
          },
          {
            label: "Status",
            secondaryText:
              statusCellProps?.text || statusCellProps?.secondaryText,
            pill: statusCellProps?.pill,
            hideValue: true
          },
          { label: "Client name", value: name }
        ]}
      />
    </WSElement>
  );
};
